/** Presets for the report and dashboard range pickers. */
export interface Preset {
  id: string;
  label: string;
  range: { from?: string; to?: string; fy?: string };
}

const iso = (d: Date) => d.toISOString().slice(0, 10);

export function presets(now = new Date()): Preset[] {
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();

  // Indian financial year runs 1 April to 31 March, so before April you are
  // still inside the FY that began the previous calendar year.
  const currentFy = month >= 3 ? year : year - 1;

  const last12 = new Date(Date.UTC(year, month - 11, 1));

  return [
    { id: "all", label: "All time", range: {} },
    { id: "12m", label: "Last 12 months", range: { from: iso(last12), to: iso(now) } },
    { id: "cy", label: `${year}`, range: { from: `${year}-01-01`, to: `${year}-12-31` } },
    { id: "fy", label: `FY ${currentFy}-${String(currentFy + 1).slice(2)}`, range: { fy: String(currentFy) } },
    {
      id: "fyprev",
      label: `FY ${currentFy - 1}-${String(currentFy).slice(2)}`,
      range: { fy: String(currentFy - 1) },
    },
  ];
}
